module.exports = __webpack_public_path__ + "static/media/icon-twitter.43449f1c.svg";